import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SearchX, ArrowRight } from "lucide-react";

/* ------------------------------------------------------------------ */
/*  EmptyState — generic empty/no-results placeholder                  */
/* ------------------------------------------------------------------ */

export default function EmptyState({
  icon: Icon = SearchX,
  title = "Nothing matches those filters.",
  message = "Adjust your specialty, state or rate filters and try again.",
  action,
  actionTo,
  onAction,
  testid = "empty-state",
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-10 lg:p-14 text-center"
      data-testid={testid}
    >
      <div className="mx-auto w-16 h-16 rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-slate-400 shadow-card">
        <Icon className="w-7 h-7" strokeWidth={1.6} />
      </div>
      <div className="mt-5 font-display font-black text-2xl text-slate-900 text-balance">{title}</div>
      <p className="mt-2.5 text-[14px] text-slate-600 leading-relaxed max-w-[42ch] mx-auto">{message}</p>
      {action && (actionTo || onAction) && (
        actionTo ? (
          <Link
            to={actionTo}
            className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-trital-navy text-white text-[13px] font-semibold btn-lift hover:bg-trital-navy-deep"
            data-testid={`${testid}-action`}
          >
            {action} <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.8} />
          </Link>
        ) : (
          <button
            type="button"
            onClick={onAction}
            className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-trital-navy text-white text-[13px] font-semibold btn-lift hover:bg-trital-navy-deep"
            data-testid={`${testid}-action`}
          >
            {action} <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.8} />
          </button>
        )
      )}
    </motion.div>
  );
}
